import React from "react";
import PropTypes from "prop-types";
import CompactMetricCard from "src/components/InsightsPage/Cards/CompactMetricCard";

const SpanMetric = ({ metric, orgMetric, loading, targetChanged }) => {
  return (
    <CompactMetricCard
      icon={["far", "sitemap"]}
      title="Avg Span"
      current={metric.current}
      currentFormatted={metric.current?.toFixed(2)}
      target={metric.target}
      targetFormatted={metric.targetFormatted}
      deltaFormatted={metric.deltaFormatted}
      ragStatus={metric.ragStatus}
      loading={loading}
      targetChanged={targetChanged}
      orgSpan={orgMetric}
    />
  );
};

SpanMetric.propTypes = {
  metric: PropTypes.shape({
    current: PropTypes.number,
    target: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
    targetFormatted: PropTypes.string,
    deltaFormatted: PropTypes.string,
    ragStatus: PropTypes.string,
  }).isRequired,
  orgMetric: PropTypes.shape({
    current: PropTypes.number,
  }),
  loading: PropTypes.bool,
  targetChanged: PropTypes.bool,
};

export default SpanMetric;
